import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
import React, { createContext, useContext, useMemo, useRef } from "react";
import useMeasure from "react-use-measure";
import { useDebounce } from "@jutro/platform";
import { useDynamicStyles } from "./hooks/useDynamicStyles";
import { useVisibilityManager } from "./hooks/useVisibilityManager";
export var QuickViewContainerContext = createContext(null);
export var QuickViewContext = createContext(null);
export var QuickViewProvider = function (_ref) {
  var children = _ref.children,
    parentContext = useContext(QuickViewContext),
    _useMeasure = useMeasure({
      scroll: !0
    }),
    _useMeasure2 = _slicedToArray(_useMeasure, 2),
    measureContainer = _useMeasure2[0],
    containerBounds = _useMeasure2[1],
    containerRef = useRef(null),
    manager = useVisibilityManager(),
    styles = useDynamicStyles(containerBounds),
    stylesDebounced = useDebounce(styles, 16),
    quickViewContext = useMemo(function () {
      return parentContext || function (e) {
        for (var r = 1; r < arguments.length; r++) {
          var t = null != arguments[r] ? arguments[r] : {};
          r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
            _defineProperty(e, r, t[r]);
          }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
            _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
          });
        }
        return e;
      }({
        containerRef: containerRef,
        styles: stylesDebounced
      }, manager);
    }, [stylesDebounced, manager, parentContext]),
    quickViewContainerContext = useMemo(function () {
      return function (element) {
        measureContainer(element), containerRef.current = element;
      };
    }, []);
  return React.createElement(QuickViewContainerContext.Provider, {
    value: quickViewContainerContext
  }, React.createElement(QuickViewContext.Provider, {
    value: quickViewContext
  }, children));
};
export var useQuickViewInternal = function () {
  var contextValue = useContext(QuickViewContext);
  if (!contextValue) throw new Error("Please check that your app is wrapped in QuickViewProvider");
  return contextValue;
};
export var useQuickViewContainer = function () {
  var contextValue = useContext(QuickViewContainerContext);
  if (!contextValue) throw new Error("Please check that your app is wrapped in QuickViewProvider");
  return contextValue;
};
QuickViewProvider.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "QuickViewProvider"
}, QuickViewProvider.__docgenInfo = {
  componentName: "QuickViewProvider",
  packageName: "@jutro/quick-view",
  description: "",
  displayName: "QuickViewProvider",
  methods: [],
  actualName: "QuickViewProvider"
};